'use client';

import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { useReducer } from 'react';

import { languages } from '@/shared/config/i18n';
import { LocaleType } from '@/shared/lib/i18n';
import PcButton from '@/shared/ui/button/PcButton';

const LOCALE_COOKIE_NAME = 'VS_LOCALE';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 365일

const PcLanguageSwitcher = () => {
  const [isOpen, toggleIsOpen] = useReducer((state) => !state, false);
  const pathname = usePathname(); // 예: /en/about
  const searchParams = useSearchParams(); // 예: ?foo=bar
  const locale = pathname?.split('/')[1];
  const currentLanguage = languages.find((lang) => lang.value === locale);

  // 기존 pathname에서 언어 코드를 제외한 나머지 경로
  const segments = pathname?.split('/') || [];
  const restOfPath = segments.length > 1 ? segments.slice(2).join('/') : '';
  const queryString = searchParams?.toString() ? `?${searchParams.toString()}` : '';

  const setLocaleCookie = (locale: LocaleType) => {
    const options = [
      `${LOCALE_COOKIE_NAME}=${locale}`,
      'path=/',
      `max-age=${COOKIE_MAX_AGE}`,
      'SameSite=Lax',
    ];

    // 환경변수로 도메인 설정이 있으면 추가
    if (process.env.NEXT_PUBLIC_TOP_DOMAIN) {
      options.push(`domain=${process.env.NEXT_PUBLIC_TOP_DOMAIN}`);
    }

    document.cookie = options.join('; ');
  };
  const getPathOnLocaleChange = (locale: LocaleType) => {
    const listPath = restOfPath.split('/');
    listPath.pop();
    const newPath = listPath.join('/');
    window.location.href = `/${locale}/${newPath}`;
  };

  return (
    <>
      <div className="relative">
        <PcButton
          onClick={toggleIsOpen}
          className={'px-4 py-2 min-w-[105px] text-center !text-[14px]'}
          variant={'solidBlack'}
        >
          {currentLanguage?.label}
        </PcButton>
        {isOpen && (
          <ul className="text-[14px] z-50 text-center absolute flex flex-col top-[48px] right-0 bg-secondary-black text-white rounded-[16px] py-[8px] w-[105px] cursor-pointer">
            {languages.map((language) => {
              const href = `/${language.value}${restOfPath ? '/' + restOfPath : ''}${queryString}`;
              return (
                <a
                  key={language.value}
                  onClick={(e) => {
                    e.preventDefault();
                    setLocaleCookie(language.value);
                    // 하드 리로드 강제
                    pathname && pathname.indexOf('travel') > -1 && segments.length === 5
                      ? getPathOnLocaleChange(language.value)
                      : (window.location.href = href);
                  }}
                >
                  <li
                    className={`py-[8px] px-[16px] ${
                      currentLanguage?.value === language.value ? 'text-white' : 'text-[#848484]'
                    }`}
                  >
                    {language.label}
                  </li>
                </a>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

export default PcLanguageSwitcher;
